module.exports = __webpack_public_path__ + "img/icon_subject.c99de498.gif";